// extracted by mini-css-extract-plugin
module.exports = {"modal":"DeleteListModal_modal__15Kmh","modal_background":"DeleteListModal_modal_background__25d59","modalContent":"DeleteListModal_modalContent__2h2gF"};